import { Link } from "react-router-dom";
import { brand, contactValue } from "../../config/brand";
import { Dots } from "../motion/Reveal";
import Icon from "../Icon";

const QUICK_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Destinations", to: "/destinations" },
  { label: "Institutes", to: "/institutes" },
  { label: "Scholarships", to: "/scholarships" },
  { label: "Pathway Programs", to: "/pathway-programs" },
];

const SERVICE_LINKS = [
  { label: "Counselling", to: "/services#education-counselling" },
  { label: "University Selection", to: "/services#university-selection" },
  { label: "Applications", to: "/services#application-support" },
  { label: "Scholarships", to: "/services#scholarship-guidance" },
  { label: "Visa Guidance", to: "/services#visa-guidance" },
  { label: "Pre-Departure Support", to: "/services#pre-departure-support" },
];

export default function Footer() {
  return (
    <footer className="bg-navy-dark text-white" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-4 py-16 sm:px-6 lg:px-10 lg:py-20">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <img src={brand.logoWhite} alt="Suvera Academy" className="h-9 w-auto" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/60">
              {brand.description}
            </p>
            <Dots className="mt-6" />
            <div className="mt-6 flex items-center gap-3" data-testid="footer-social-links">
              {[
                { key: "instagram", icon: "Instagram", label: "Instagram" },
                { key: "facebook", icon: "Facebook", label: "Facebook" },
                { key: "linkedin", icon: "Linkedin", label: "LinkedIn" },
                { key: "youtube", icon: "Youtube", label: "YouTube" },
              ]
                .filter((s) => brand.socialLinks[s.key])
                .map((s) => (
                  <a
                    key={s.key}
                    href={brand.socialLinks[s.key]}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Suvera Academy on ${s.label}`}
                    className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-white/60 transition-colors duration-200 hover:border-dot-amber hover:text-dot-amber"
                    data-testid={`social-link-${s.key}`}
                  >
                    <Icon name={s.icon} className="h-4 w-4" />
                  </a>
                ))}
            </div>
          </div>
          <div className="lg:col-span-2">
            <h3 className="font-mono-accent text-xs uppercase tracking-[0.25em] text-white/40">Quick Links</h3>
            <ul className="mt-5 space-y-2.5">
              {QUICK_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-white/70 transition-colors duration-150 hover:text-white" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-3">
            <h3 className="font-mono-accent text-xs uppercase tracking-[0.25em] text-white/40">Services</h3>
            <ul className="mt-5 space-y-2.5">
              {SERVICE_LINKS.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-white/70 transition-colors duration-150 hover:text-white" data-testid={`footer-service-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-3">
            <h3 className="font-mono-accent text-xs uppercase tracking-[0.25em] text-white/40">Contact</h3>
            <ul className="mt-5 space-y-2.5 text-sm text-white/70" data-testid="footer-contact-details">
              <li>Phone: {contactValue(brand.phone)}</li>
              <li>Email: {contactValue(brand.email)}</li>
              <li>Address: {contactValue(brand.address)}</li>
              <li>WhatsApp: {contactValue(brand.whatsapp)}</li>
            </ul>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-white/40">© 2026 Suvera Academy. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy-policy" className="text-xs text-white/40 transition-colors duration-150 hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms-and-conditions" className="text-xs text-white/40 transition-colors duration-150 hover:text-white" data-testid="footer-terms-link">Terms &amp; Conditions</Link>
            <Link to="/cookie-policy" className="text-xs text-white/40 transition-colors duration-150 hover:text-white" data-testid="footer-cookies-link">Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
